(() => {
  const setup = (root) => {
    if (!root || root.dataset.ammGiftProgressInitialized === 'true') return;
    root.dataset.ammGiftProgressInitialized = 'true';

    const reveal = () => {
      root.classList.add('is-inview');
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveal();
      return;
    }

    if (typeof IntersectionObserver !== 'function') {
      reveal();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal();
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(root);
  };

  const init = (scope) => {
    (scope || document).querySelectorAll('[data-amm-gift-progress]').forEach(setup);
  };

  init(document);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
